import { atom } from "jotai";
import { BuiltInApp } from "../types";

export const interfacesAppAtom = atom<BuiltInApp | null>(null);
interfacesAppAtom.debugLabel = "interfacesAppAtom";
